import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  TotalSale: {},
  TotalPurchase: {},
  TotalFarmer: {},
  TotalProduct: {},
  TotalOrder: {},
  TotalFranchise: {},
  TotalComission: {},
  FranchiseSales: {},
  FranchiseUser: {},
  FranchiseOrder: {},
  InchargeCommissions: {},
  InchargeTotal: {},
  TotalState: {},
  TotalDivision: {},
  TotalBlock: {},
  TotalCluster: {},
  TotalTour: {},
  TotalReward: {},
  InchargeVillage: {},
  StateMap: [],
  FranchiseCommission: {},
  Notification: [],
  AdminWallet: {},
};
//internally using immer lib (can create mutable state)
export const dashBoardSlice = createSlice({
  name: "dashBoardData",
  initialState,
  reducers: {
    updateAllTotalSale: (state, action) => {
      state.TotalSale = action.payload;
    },
    updateAllTotalPurchase: (state, action) => {
      state.TotalPurchase = action.payload;
    },
    updateAllTotalFarmer: (state, action) => {
      state.TotalFarmer = action.payload;
    },
    updateAllTotalProduct: (state, action) => {
      state.TotalProduct = action.payload;
    },
    updateAllTotalOrder: (state, action) => {
      state.TotalOrder = action.payload;
    },
    updateAllTotalFranchise: (state, action) => {
      state.TotalFranchise = action.payload;
    },
    updateAllTotalComission: (state, action) => {
      state.TotalComission = action.payload;
    },
    updateTotalState: (state, action) => {
      state.TotalState = action.payload;
    },
    updateTotalDivision: (state, action) => {
      state.TotalDivision = action.payload;
    },
    updateTotalBlock: (state, action) => {
      state.TotalBlock = action.payload;
    },
    updateTotalCluster: (state, action) => {
      state.TotalCluster = action.payload;
    },
    updateTotalTour: (state, action) => {
      state.TotalTour = action.payload;
    },
    updateTotalReward: (state, action) => {
      state.TotalReward = action.payload;
    },
    updateInchargeCommission :(state, action) => {
      state.InchargeCommissions = action.payload;
    },
    updateInchargeTotal :(state, action) => {
      state.InchargeTotal = action.payload;
    },
    updateFranchiseOrder : (state, action) => {
      state.FranchiseOrder = action.payload;
    },
    updateFranchiseUser : (state, action) => {
      state.FranchiseUser = action.payload;
    },
    updateFranchiseSales : (state, action) => {
      state.FranchiseSales = action.payload;
    },
    updateVillageFranchise : (state, action) => {
      state.InchargeVillage = action.payload;
    },
    updateFranchiseCommission : (state, action) => {
      state.FranchiseCommission = action.payload;
    },
    updateStateMap : (state, action) => {
      state.StateMap = action.payload;
    },
    updateNotification : (state, action) => {
      state.Notification = action.payload;
    },
    updateAdminWallet : (state, action) => {
      state.AdminWallet = action.payload;
    },
  },
});
// this is for dispatch
export const {
  updateAllTotalSale,
  updateAllTotalFarmer,
  updateAllTotalProduct,
  updateAllTotalOrder,
  updateAllTotalFranchise,
  updateAllTotalComission,
  updateInchargeTotal,
  updateInchargeCommission,
  updateFranchiseOrder,
  updateFranchiseUser,
  updateFranchiseSales,
  updateTotalState,
  updateTotalBlock,
  updateTotalCluster,
  updateTotalDivision,
  updateTotalReward,
  updateTotalTour,
  updateAllTotalPurchase,
  updateVillageFranchise,
  updateStateMap,
  updateFranchiseCommission,
  updateNotification,
  updateAdminWallet,
} = dashBoardSlice.actions;
// this is for configureStore
export default dashBoardSlice.reducer;
